module.exports = __webpack_public_path__ + "img/email-envelope.2caffb6b.svg";